import React, { useState } from "react";
import ConfirmationModal from "./ConfirmationModal";
import LinkifiedText from "./LinkifiedText";

/**
 * Shared event-card description snippet: first ~3 lines + "Read More" dialog.
 * Renders nothing when description is empty/whitespace.
 *
 * Use on every EventCalendar-style hero card (calendar, Events list, Close Record,
 * QR check-in, registered cards) so description UX stays consistent.
 */
function EventDescriptionPreview({
  description,
  dialogTitle = "Description",
  className = "",
}) {
  const [open, setOpen] = useState(false);
  const text = description != null ? String(description).trim() : "";
  if (!text) return null;

  const rootClass = ["card-event-description", className].filter(Boolean).join(" ");

  return (
    <>
      <div className={rootClass}>
        <div className="card-event-description-preview">{text}</div>
        <button
          type="button"
          className="btn-link card-event-description-read-more"
          onClick={(e) => {
            e.stopPropagation();
            setOpen(true);
          }}
          aria-label="Read full event description"
        >
          Read More <span className="card-event-description-chevron" aria-hidden="true">⌄</span>
        </button>
      </div>
      <ConfirmationModal
        open={open}
        mode="alert"
        title={dialogTitle || "Description"}
        contentMaxWidth={560}
        confirmLabel="Close"
        message={
          <div className="modal-description-text">
            <LinkifiedText text={text} />
          </div>
        }
        onConfirm={() => setOpen(false)}
        onCancel={() => setOpen(false)}
      />
    </>
  );
}

export default EventDescriptionPreview;
